import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

// True only when both env vars are present. The UI uses this to show a
// friendly "not configured yet" message instead of throwing network errors.
export const isSupabaseConfigured = Boolean(url && key);

// Always construct a client (with harmless placeholders if unconfigured) so
// imports never crash. Calls simply fail until real keys are provided.
export const supabase = createClient(
  url || 'https://placeholder.supabase.co',
  key || 'placeholder-anon-key',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);
